import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";
import { useSearchParams } from "react-router-dom";
import Moment from "react-moment";
import Styles from "Styles/Styles.module.css";
import ReactPaginate from "react-paginate";
import { customerTypes } from "./Types";
import { showWarningAlert, showErrorAlert } from "Util/Alerts";
import { getUsers } from "Services/Requests";

function UsersComp() {
    let TableHead = ["CUSTOMER NAME", "MOBILE", "EMAIL", "CREATED AT"];

    const [searchParams, setSearchParams] = useSearchParams();
    const [forcepage, setfocrcepage] = useState(0);
    const [Count, setCount] = useState(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [customers, setcustomers] = useState<customerTypes[]>([]);

    const getcustomers = async (page: any) => {
        try {
            const response = await getUsers(page);
            console.log(response);
            if (response?.data?.status === 1) {
                setcustomers(response?.data?.users);
                setCount(response?.data?.pageCount);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let page = searchParams.get("page") ?? 1;
        getcustomers(page);
    }, []);
    const handlePageChange = (selectedObject: any) => {
        console.log(selectedObject);
        // setcurrentPage(selectedObject.selected);
        // handleFetch();

        setSearchParams({
            page: selectedObject.selected + 1,
        });

        setfocrcepage(selectedObject.selected);
        getcustomers(selectedObject.selected + 1);
        window.scrollTo({ top: 10, behavior: "smooth" });
    };

    return (
        <div className={Styles["Container"]}>
            <header>
                <h3>Users</h3>
                {/*  <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/admin/auth/customers/add")}>
                    <FiPlus />
                    Add Banner
                </button> */}
            </header>

            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {customers?.length > 0 ? (
                                customers?.map((item) => (
                                    <tr key={item?.user_id}>
                                        <td>
                                            {item?.first_name} {item?.last_name}
                                        </td>
                                        <td>{item.mobile_number}</td>
                                        <td>{item?.email}</td>
                                        <td>
                                            <Moment format="DD-MM-YYYY">
                                                {item?.createdAt}
                                            </Moment>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No customers Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {customers?.length > 0 && (
                        <ReactPaginate
                            pageCount={Count}
                            // pageRange={2}
                            forcePage={forcepage}
                            marginPagesDisplayed={2}
                            onPageChange={handlePageChange}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default UsersComp;
